import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { TrainingDate } from '../../models/training-date.interface';
import { LineUpEditorPage } from '../../pages/line-up-editor/line-up-editor';
import { ApiProvider } from '../../providers/api/api'
// import { Ionic2RatingModule } from 'ionic2-rating'
import { TrainingResultEditorPage} from '../../pages/training-result-editor/training-result-editor'

@IonicPage({
//   name: 'page-line-up',
     segment: 'line-up/:id',
     defaultHistory: ['TrainingOverviewPage']
})
@Component({
  selector: 'page-line-up',
  templateUrl: 'line-up.html',
})
export class LineUpPage {

  lineUps: any[];
  errorMessage: String;
  trainingDateObj: TrainingDate;
  trainingDateId: string;
  rate: any;
  result: any;
  readonlyPage = false;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              public modalCtrl: ModalController,
              private api: ApiProvider) {
    
    this.trainingDateId = navParams.get('id');
    this.trainingDateObj = navParams.get('trainingDate') || {};
    this.readonlyPage = navParams.get('readonlyPage') || false;
    this.lineUps = new Array<any>();
    
    this.api.getEntity("lineUp", this.trainingDateId).subscribe(
      data => {this.lineUps = data}
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LineUpPage');
  }

  openEditor(){
    console.log('openEditor');
    // take training date obj and hand over player array
    // later reloads

    console.log(this.trainingDateObj);

    // open modal
    let editorModal = this.modalCtrl.create(LineUpEditorPage, this.trainingDateObj.Players);
    
    editorModal.onDidDismiss(data => {
      if(data){
        console.log("push data: " + data);
        
        // calculate training date
        var utcDate = new Date(Date.parse(this.trainingDateObj.Label));
        utcDate.setMinutes(utcDate.getMinutes() - utcDate.getTimezoneOffset());
        var keyDate = new Date(Date.now());
        keyDate.setMonth(utcDate.getMonth());
        keyDate.setDate(utcDate.getDate());
        console.log(keyDate.toISOString());

        this.api.saveEntity("lineUp", this.trainingDateObj.Id, keyDate.toISOString(),  data)
        .subscribe( lineUp => {
                      this.lineUps.unshift(lineUp);						   
                  },
                  error => {
                    this.errorMessage = <any>error
                    console.log(this.errorMessage);
                  });

          // console.log("ondismiss: " + data.teamBlack);
      }
    });
    
    editorModal.present();
  }

  deleteEntity(lineUp: any){
    this.api.deleteEntity("lineUp", lineUp.partition, lineUp.key)
      .subscribe(deletionData => {
        this.lineUps = this.lineUps.filter(x => x.key != lineUp.key)
        console.log(deletionData);
      });
  }

  saveResult(lineUp: any) {
    console.log('save result: ' + lineUp);
    // take training date obj and hand over player array
    // later reloads

    // open modal
    let editorModal = this.modalCtrl.create(TrainingResultEditorPage, lineUp);
    
    editorModal.onDidDismiss(data => {
      if(data){
        console.log("push data: " + data.key);
        var key = data.key;
        this.api.updateEntity("lineUp", this.trainingDateObj.Id, key, data.value)
        .subscribe( lineUp => {
              var index = this.lineUps.findIndex(item =>  item.key == key);
              this.lineUps[index] = lineUp;  			   
            },
            error => {
              this.errorMessage = <any>error
              console.log(this.errorMessage);
            });
      }
    });
    editorModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/line-up/line-up.ts